import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  // user: undefined = checking, null = not logged in, object = logged in
  const [user, setUser] = useState(undefined);
  const [token, setToken] = useState(() => localStorage.getItem("tamari-admin-token"));

  const checkAuth = useCallback(async () => {
    const t = localStorage.getItem("tamari-admin-token");
    if (!t) {
      setUser(null);
      return;
    }
    try {
      const { data } = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${t}` },
      });
      setUser(data);
      setToken(t);
    } catch {
      localStorage.removeItem("tamari-admin-token");
      setToken(null);
      setUser(null);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = useCallback(async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("tamari-admin-token", data.access_token);
    setToken(data.access_token);
    setUser(data.user);
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("tamari-admin-token");
    setToken(null);
    setUser(null);
  }, []);

  const authHeaders = useCallback(
    () => (token ? { Authorization: `Bearer ${token}` } : {}),
    [token]
  );

  const value = useMemo(
    () => ({ user, token, login, logout, authHeaders }),
    [user, token, login, logout, authHeaders]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
